import * as React from 'react';
import styles from '../focus-import.module.css';
import { IconAlertSmall } from '@SBGSports/referee-react/icons';
import { Typography, Variables } from '@SBGSports/referee-react';
import { useTranslations } from 'i18n';

export const ImportRetryErrorFeedback: React.FC = () => {
    const { __ } = useTranslations();

    return (
        <div className={styles['import-feedback-wrapper']}>
            <div className={styles['error-wrapper']}>
                <IconAlertSmall color={Variables?.css?.alert} />
                <Typography variant="body-2">{__('misc.something_went_wrong')}</Typography>
                <Typography variant="body-1">{__('smt_importer.please_retry_import')}</Typography>
            </div>
        </div>
    );
};
